import React from 'react';

const CustomSelect = () => {
  return (
    <>
      <iframe height="455" style={{ width: "100%"}} scrolling="no" title="Isolated Custom Select" src="https://codepen.io/Venser/embed/bGpYzbq?height=455&theme-id=dark&default-tab=html,result" frameBorder="no" loading="lazy" allowFullScreen={true}>
        See the Pen <a href='https://codepen.io/Venser/pen/bGpYzbq'>Isolated Custom Select</a> by Daniel (<a href='https://codepen.io/Venser'>@Venser</a>) on <a href='https://codepen.io'>CodePen</a>.
      </iframe>
    </>
  )
}

export default CustomSelect;
